/**
 * Admin card to run Global-E to ReturnGo Shopify portal migration; warns when a prior completed migration exists for the selected store.
 */
import { observer } from "mobx-react-lite";
import React from "react";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import { Button } from "../../../components/inputs/button/button";
import GlobaleEnvironmentSelector from "./components/globale-environment-selector/globale-environment-selector";
import Card from "../../../components/layouts/card/card";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";
import ShopsSelector from "../../../components/shops-selector/shops-selector";
import { FormFieldLine } from "../../../components/form-field-line/form-field-line";
import migrateGlobaleShopifyPlatformStore from "./stores/migrate-globale-shopify-platform.store";
import { Input } from "../../../components/inputs/input/input";
import { isSet } from "../../../models/model-types-methods";
import { Note, NOTE_TYPE } from "../../../components/note/note";

function formatMigrationRunDate(isoDate: string | null): string {
    if (!isoDate) {
        return "a previous migration run";
    }
    return new Date(isoDate).toLocaleString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

const MigrateGlobaleShopifyPlatformCard: React.FC = observer(() => {
    const store = migrateGlobaleShopifyPlatformStore;

    return (

        <Card isExpanded={true}
            toolbar={{title: 
                <>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Migrate Shopify Platform Global-E Store </FontBody1> 
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>(backend/shopify)</FontBody1>
                </>
            }}  
        >
            <ListLayout>
                <FormFieldLine label="Select Shopify portal to migrate">
                    <ShopsSelector value={store.portal} onChange={store.setPortal} disabled={store.isProcessing || isSet(store.portal[0])} includeSecondaryPortals />
                </FormFieldLine>

                {isSet(store.portal[0]) && isSet(store.lastCompletedMigrationAttempt) ? (
                    <Note
                        type={NOTE_TYPE.WARNING}
                        caption="PAY ATTENTION"
                        body={
                            <>
                                This store was migrated in{" "}
                                {formatMigrationRunDate(store.lastCompletedMigrationAttempt.migration_finished_at)}. Rerunning the migration will delete
                                migration entities such as policies and return methods and recreate them. It is not advised to rerun the migration for a fully
                                live merchant.
                            </>
                        }
                    />
                ) : null}

                <FormFieldLine label="Global-E Merchant ID">
                    <Input value={store.gobaleMerchantId} required disabled />
                </FormFieldLine>

                <GlobaleEnvironmentSelector value={store.env} disbled />

                <Button
                    onClick={store.submit}
                    text="Start migration"
                    hasLoader={true}
                    isLoading={store.isProcessing}
                    disabled={store.isProcessing || !store.isValid}
                />

            </ListLayout>

        </Card>

    );
});

export default MigrateGlobaleShopifyPlatformCard;
